import React from 'react';
import { components } from 'react-select';
import Checkbox from 'src/ui/library/Checkbox';

const CheckboxOption = ({ children, ...props }) => {
  const { Option } = components;

  const searchText = props.selectProps.inputValue || null;
  const highlight = (needle, haystack) => haystack.replace(new RegExp(needle, 'gi'), str => `<strong>${str}</strong>`);
  const labelText = props.data.label !== null && props.data.label.length >= 1 ? highlight(searchText, props.data.label) : '';

  const { isSelected } = props;

  return (
    <Option {...props}>
      <Checkbox className="multiselect-option" checked={isSelected} key={isSelected} />
      <span style={{ paddingLeft: 10 }} className="option-text" dangerouslySetInnerHTML={{ __html: labelText }} />
    </Option>
  );
};

export default CheckboxOption;
